<template>
	<div>
	<div class="robotComponent3">
		<div class="shuziren" style="z-index:2147483646;">
			<div v-if="!show1">
				<div class="robotButton" @click="clicktrue()" >
					<div class="shuzirenRound">
						<img  class="shuzirenRoundImg" src="~@/assets/images/exposition/humansmall.png" alt="">
					</div>
					<div class="shuzirenIcon1">
						<img class="shuzirenIconImg" v-if="show1===false"
							src="~@/assets/images/exposition/minimize.png" alt="">
						<img class="shuzirenIconImg" v-if="show1===true"
							src="~@/assets/images/exposition/maximize.png" alt="">
					</div>
		
				</div>
			</div>
		</div>
		<div v-if="show1" class="robot" style="z-index: 111111111111111111;">
			<newRobot></newRobot>
		</div>
	</div>
	</div>
</template>

<script>
	import newRobot from "@/views/exposition/components/robat3/index.vue";
	export default {
		components: {
			newRobot,
		},
		data() {
			return {
				show1: false,
			};
		},
		methods: {
			clicktrue() {
				this.show1 = !this.show1;
				console.log(this.show1, 'this.show1')
				this.$EventBus.$emit('clicktrue', this.show1)	
			},
		},
		mounted() {
			this.$EventBus.$on('clicktrue2', (show2) => {
				// console.log(show2, 'this.show1this.show1this.show2222222222222222222222')
				if (show2) {
					this.show1 = true;
				} else {
					this.show1 = false;
				}
			})
		},
	}
</script>

<style lang="scss" scope>
	.robotComponent3{
		.shuziren {
			position: absolute;
			bottom: 33px;
			left: 44%;
			width: 270px;
			height: 100px;
		
			.robotButton {
				z-index: 1000009;
				display: flex;
				// position:absolute;
				// left:8px;
				// bottom:200px;
				width: 240px;
				height:100px;
				background-image: url("~@/assets/images/exposition/shuzirenBtn.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
		
				.shuzirenRound {
		
					border-radius: 50%;
					width:100px;
					height:100px;
					background-image: url("~@/assets/images/exposition/shuzirenRound.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
		            .shuzirenRoundImg{
						display: block;
						width:95px;
						height:95px;
						border-radius: 50%;
					} 
				}
				.shuzirenIcon1 {
					margin-top: 20px;
					margin-left:50px;
		
					.shuzirenIconImg {
						display: block;
						width:60px;
						height:60px;
					}
				}
			}
		}
	}
</style>